
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Loader from '../Utilities/Loader';


const Login = ({ userInfo, loginUser }) => {
    const [emailError, setEmailError] = useState("");
    const [isUpdateLoading, setUpdateLoading] = useState(false);


    const loginSubmit = async (values) => {
        setUpdateLoading(true);
        await loginUser({
            email: values.email,
            password: values.password
        }).then(({ message }) => {
            setUpdateLoading(false);
            setEmailError(message);
        }).catch(({ message }) => {
            setEmailError(message);
        })
    }

    return (
        <div className="flex h-screen w-full">
            {/* Login section */}
            <div className="flex flex-col items-center justify-center w-full px-4">
                <div className="flex border rounded-xl px-3.5 py-4 shadow-200 mb-12">
                    <svg width="69" height="64" viewBox="0 0 69 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M35.9179 33.186C37.0225 33.186 37.9179 34.0814 37.9179 35.186V41.5721C37.9179 43.4275 38.5926 45.3953 39.942 47.4756C42.6407 51.6924 46.464 53.8008 51.4117 53.8008H57.1706C58.2751 53.8008 59.1706 52.9054 59.1706 51.8008V50.4033C59.1706 49.2987 58.2751 48.4033 57.1706 48.4033H51.243C49.8374 48.4033 48.4037 47.9254 46.9419 46.9696C44.5805 45.3953 43.3998 43.54 43.3998 41.4034V35.186C43.3998 34.0814 44.2952 33.186 45.3998 33.186H47.4725C48.5771 33.186 49.4725 32.2906 49.4725 31.186V30.7287C49.4725 29.6241 48.5771 28.7287 47.4725 28.7287H45.3998C44.2952 28.7287 43.3998 27.8333 43.3998 26.7287V21.5002C43.3998 20.3195 43.8777 19.0826 44.8335 17.7894C46.5764 15.5967 48.7129 14.4722 51.243 14.416H57.1706C58.2751 14.416 59.1706 13.5206 59.1706 12.416V11.1028C59.1706 9.99826 58.2751 9.10283 57.1706 9.10283H51.1586C47.8414 9.10283 44.8616 10.2835 42.2191 12.6449C39.3516 15.175 37.9179 17.9862 37.9179 21.0785V26.7287C37.9179 27.8333 37.0225 28.7287 35.9179 28.7287H33.6259C32.5214 28.7287 31.6259 27.8333 31.6259 26.7287V21.2472C31.6259 19.3356 30.9231 17.3396 29.5175 15.2593C26.6501 11.0988 22.4895 9.01849 17.0358 9.01849H11.6986C10.594 9.01849 9.69862 9.91392 9.69862 11.0185V12.416C9.69862 13.5206 10.594 14.416 11.6986 14.416H17.0358C19.3972 14.416 21.4494 15.0626 23.1923 16.3557C25.104 17.8738 26.0598 19.5886 26.0598 21.5002V26.7287C26.0598 27.8333 25.1643 28.7287 24.0598 28.7287H20.8287C19.7241 28.7287 18.8287 29.6241 18.8287 30.7287V31.186C18.8287 32.2906 19.7241 33.186 20.8287 33.186H24.0598C25.1643 33.186 26.0598 34.0814 26.0598 35.186V41.4034C26.0598 42.4155 25.7786 43.3994 25.2164 44.3552C23.7546 47.0539 21.2245 48.4033 17.6262 48.4033H12.1203C11.0157 48.4033 10.1203 49.2987 10.1203 50.4033V51.8008C10.1203 52.9054 11.0157 53.8008 12.1203 53.8008H17.5418C21.7024 53.8008 25.1883 52.3952 27.9995 49.584C30.4171 47.1102 31.6259 44.4676 31.6259 41.6565V35.186C31.6259 34.0814 32.5214 33.186 33.6259 33.186H35.9179ZM65.1343 0C64.0298 0 63.1343 0.895431 63.1343 2V51.8008C63.1343 52.9054 64.0298 53.8008 65.1343 53.8008H66.8692C67.9737 53.8008 68.8692 52.9054 68.8692 51.8008V2C68.8692 0.89543 67.9737 0 66.8692 0H65.1343ZM2 9.01849C0.89543 9.01849 0 9.91392 0 11.0185V62C0 63.1046 0.895431 64 2 64H3.73484C4.8394 64 5.73484 63.1046 5.73484 62V11.0185C5.73484 9.91392 4.8394 9.01849 3.73483 9.01849H2Z" fill="#1D1E21" />
                    </svg>
                </div>
                <Formik
                    enableReinitialize={false}
                    initialValues={{
                        email: "",
                        password: "",
                    }}
                    validationSchema={Yup.object().shape({
                        email: Yup.string().email('Invalid email').required('Email is required'),
                        password: Yup.string().required("Password is required"),
                    })}
                    onSubmit={(values) => loginSubmit(values)}
                >
                    {({ errors, touched }) => (
                        <Form className="flex flex-col justify-center max-w-360 w-full">
                            <div className="relative mb-5 ">
                                <Field className="appearance-none focus:outline-none focus:border-primary-navyBlue transition delay-150 duration-150 ease-linear text-base border rounded-md py-3 px-4 max-w-360 w-full  placeholder-secondary-grey-300 text-secondary-grey-600 font-normal border-secondary-grey-400"
                                    type="text"
                                    name="email"
                                    placeholder='Email' />
                                {errors.email && touched.email && <span className="block text-red-500 text-xs border px-3 py-2 rounded-md mt-1 font-title ">{errors.email}</span>}
                            </div>
                            <div className="relative mb-5">
                                <Field className="appearance-none focus:outline-none focus:border-primary-navyBlue transition delay-150 duration-150 ease-linear text-base border rounded-md py-3 px-4 max-w-360 w-full placeholder-secondary-grey-300 text-secondary-grey-600 font-normal border-secondary-grey-400"
                                    type="password"
                                    name="password"
                                    placeholder='Password' />
                                {errors.password && touched.password && <span className="block text-red-500 text-xs border px-3 py-2 rounded-md mt-1 font-title">{errors.password}</span>}
                            </div>
                            <div className="relative mb-6">
                                <button 
                                disabled={isUpdateLoading}
                                className="flex items-center justify-center  max-w-360 w-full p-4 bg-primary-navyBlue hover:bg-opacity-75 transition delay-150 duration-150 ease-linear text-white rounded-md text-sm font-semibold font-title"
                                    type="submit"
                                >Login
                                {isUpdateLoading ? <Loader /> : null}
                                </button>
                                {emailError?.length > 0 && <div className="w-full text-red-500 text-xs border px-3 py-2 rounded-md mt-1  font-title flex justify-center">{emailError}</div>}
                            </div>

                        </Form>
                    )}
                </Formik>
                <Link to="/forgot-password" className="border-0 bg-white hover:text-opacity-75 transition delay-150 duration-150 ease-linear text-secondary-blue-400 rounded-md text-sm font-medium font-title">Forgot Password?</Link>
            </div>
            {/* Banner section and it's not visible in the mobile view */}
            <div className="hidden md:flex px-4 bg-primary-navyBlue md:flex-col md:items-center md:justify-center w-full">
                <div className="mb-16">
                    <img className="" src='/images/login-image.png' alt='login banner' />
                </div>
                <div className="text-center">
                    <h3 className="text-xl text-white font-title font-medium mb-2">Build complete documentation of your project.</h3>
                    <p className="mb-0 text-sm text-secondary-blue-500 font-medium">Take a look at all information about a project at glance.</p>
                </div>
            </div>
        </div>
    );
}


const mapState = (state) => ({
    userInfo: state.auth.userInfo,
});

const mapDispatch = (dispatch) => ({
    loginUser: dispatch.auth.loginUser,
});

export default connect(mapState, mapDispatch)(Login)